import React from "react";

const BgImageWithLeftText = ({heading,content}) => {
  return (
    <div style={{ backgroundImage: `url('https://keyzi.com.au/keyzi-admin/public/${content?.[0]?.image}')` }}
      class="keyzi_FromTeens--wrapper keyzi_guideTestimonials--wrapper"
      id="testimonial_section"
    >
      <div class="container">
        <div class="keyzi_FromTeens--inner">
          <h2 className="text-start">{heading}</h2>
        </div>
      </div>
    </div>
  );
};

export default BgImageWithLeftText;